import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {User, UserData} from "../../../models/User";
import {Provincia} from "../../../models/Provincia";
import {Regione} from "../../../models/Regione";
import {Citta} from "../../../models/Citta";
import {DataService} from "../../../services/data.service";
import {ServerService} from "../../../services/server.service";
import {DialogService} from "../dialog/dialog.service";
import {EsercizioUtenteFactory} from "../../../models/EsercizioUtente";
import * as _ from "lodash";
import {Stato} from "../../../models/Stato";
import {MatRadioChange} from "@angular/material/radio";
import {Esercizio, EsercizioFactory} from "../../../models/Esercizio";

@Component({
   selector: 'app-amministratore-form',
   templateUrl: './amministratore-form.component.html',
   styleUrls: ['./amministratore-form.component.scss']
})
export class AmministratoreFormComponent implements OnInit, AfterViewInit {
   utente_esercizio: any;
   @Input() isNew: boolean = false;
   @Output() dataForm = new EventEmitter<boolean>();

   arrRegioni:Regione[] = []
   arrProvinceNascita:Provincia[] = []
   arrProvinceResidenza:Provincia[] = []
   arrProvinceDomicilio:Provincia[] = []
   arrCittaNascita:Citta[] = []
   arrCittaResidenza:Citta[] = []
   arrCittaDomicilio:Citta[] = []
   arrStati:Stato[] = []

   public esercizio:Esercizio = new Esercizio()

   Esercizio = Esercizio;



   public userFrm: UntypedFormGroup = new UntypedFormGroup({
         first_name: new UntypedFormControl(null, Validators.required),
         last_name: new UntypedFormControl(null, Validators.required),
         email: new UntypedFormControl(null, [Validators.required, Validators.email]),
         username: new UntypedFormControl(null, [Validators.required]),
         esercizio: new UntypedFormGroup({
            documento_legale_rapp: new UntypedFormControl(null, Validators.required),
            documento_verifica: new UntypedFormControl(null, Validators.required),
            tipo_doc_legale_rapp: new UntypedFormControl('', Validators.required),
            tipo_doc_verifica: new UntypedFormControl('', Validators.required),
         }),
         profile: new UntypedFormGroup({
            ind_res_match: new UntypedFormControl(null, Validators.required),
            data_nascita: new UntypedFormControl(null, Validators.required),
            cellulare: new UntypedFormControl(null, Validators.required),
            cellulare_prefix: new UntypedFormControl("+39", Validators.required),
            codice_fiscale: new UntypedFormControl('', Validators.required),
            indirizzo_nascita: new UntypedFormGroup({
               stato:new UntypedFormControl('', Validators.required),
               regione: new UntypedFormControl(null, Validators.required),
               provincia: new UntypedFormControl({value:null, disabled:true}, Validators.required),
               citta: new UntypedFormControl({value:null, disabled:true}, Validators.required),
            }),
            indirizzo_residenza: new UntypedFormGroup({
               stato:new UntypedFormControl('', Validators.required),
               regione:new UntypedFormControl(null, Validators.required),
               provincia:new UntypedFormControl({value:null, disabled:true}, Validators.required),
               citta:new UntypedFormControl({value:null, disabled:true}, Validators.required),
               indirizzo:new UntypedFormControl('', Validators.required),
               civico:new UntypedFormControl('', Validators.required),
               cap:new UntypedFormControl('', Validators.required)
            }),
            indirizzo_domicilio: new UntypedFormGroup({
               stato:new UntypedFormControl('', Validators.required),
               regione:new UntypedFormControl(null, Validators.required),
               provincia:new UntypedFormControl({value:null, disabled:true}, Validators.required),
               citta:new UntypedFormControl({value:null, disabled:true}, Validators.required),
               indirizzo:new UntypedFormControl('', Validators.required),
               civico:new UntypedFormControl('', Validators.required),
               cap:new UntypedFormControl('', Validators.required)
            }),
         })
      }
   )

   public flags = [
      {value: "+39", flag:"🇮🇹"}
   ]

   constructor(
      private dataSrv:DataService,
      private serverSrv: ServerService,
      private dialogSrv: DialogService,
      private eserciziUtentiFctr: EsercizioUtenteFactory,
      private esercizioFctr: EsercizioFactory

   ) {}

   ngOnInit(): void {
      this.utente_esercizio = new User(this.dataSrv.esercizioUser.esercizio.data.amministratore)

      console.log(this.utente_esercizio)

      if(this.isNew){
         this.userFrm.addControl("password", new UntypedFormControl(this.utente_esercizio?.data?.password, [Validators.required]),)
      }

      if (this.utente_esercizio) {
         this.initForm()
      }
   }

   ngAfterViewInit(): void {
      this.fetchStati()
      this.fetchRegioni()
      this.fetchEsercizio()
      console.log(this.utente_esercizio)
   }

   fetchEsercizio(){
      this.esercizioFctr.getEsercizio(this.dataSrv.esercizioUser.esercizio.data.id).then((esercizio) => {
         this.esercizio = esercizio
         this.initForm()

         console.log(this.esercizio)
      }).catch(err => {
         console.error(err)
      })
   }

   initForm(){
      console.log(this.esercizio)
      this.userFrm.patchValue(this.utente_esercizio.data)
      this.userFrm.get('esercizio')?.patchValue(this.esercizio.data)
      this.userFrm.get('profile')?.patchValue(this.utente_esercizio.data.profile.data)
      this.userFrm.get('profile')?.get('ind_res_match')?.patchValue(this.utente_esercizio.data.profile.data.ind_res_match)

      console.log(this.esercizio.data.documento_legale_rapp)
      // this.userFrm.get('esercizio')?.get('documento_legale_rapp')?.patchValue(this.esercizio.data.documento_legale_rapp)
      this.userFrm.get('profile')?.get('ind_res_match')?.patchValue(this.utente_esercizio.data.profile.data.ind_res_match)

      this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('stato')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_nascita.stato ?
            this.utente_esercizio.data.profile.data.indirizzo_nascita.stato.toString() :
            null, {emitEvent:true, onlySelf: true})

      this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('regione')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_nascita.regione ?
            this.utente_esercizio.data.profile.data.indirizzo_nascita.regione.toString() :
            null, {emitEvent:true, onlySelf: true})

      this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('stato')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_residenza.stato ?
            this.utente_esercizio.data.profile.data.indirizzo_residenza.stato.toString() :
            null, {emitEvent:true, onlySelf: true})

      this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('regione')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_residenza.regione ?
            this.utente_esercizio.data.profile.data.indirizzo_residenza.regione.toString() :
            null, {emitEvent:true, onlySelf: true})

      this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('stato')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_domicilio.stato ?
            this.utente_esercizio.data.profile.data.indirizzo_domicilio.stato.toString() :
            null, {emitEvent:true, onlySelf: true})

      this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('regione')?.patchValue(
         this.utente_esercizio.data.profile.data.indirizzo_domicilio.regione ?
            this.utente_esercizio.data.profile.data.indirizzo_domicilio.regione.toString() :
            null, {emitEvent:true, onlySelf: true})



      this.setValueProvince(this.utente_esercizio.data.profile.data.indirizzo_residenza.regione, 'indirizzo_residenza').then(() => {
         this.setValueCitta(this.utente_esercizio.data.profile.data.indirizzo_residenza.provincia, 'indirizzo_residenza')

      })
      this.setValueProvince(this.utente_esercizio.data.profile.data.indirizzo_nascita.regione, 'indirizzo_nascita').then(() => {
         this.setValueCitta(this.utente_esercizio.data.profile.data.indirizzo_nascita.provincia, 'indirizzo_nascita')

      })
      this.setValueProvince(this.utente_esercizio.data.profile.data.indirizzo_domicilio.regione, 'indirizzo_domicilio').then(() => {
         this.setValueCitta(this.utente_esercizio.data.profile.data.indirizzo_domicilio.provincia, 'indirizzo_domicilio')

      })
   }

   fetchRegioni(){
      Regione.getRegioni().then(
         (regioni) =>{
            this.arrRegioni = regioni
         }
      ).catch(err =>{
         console.error(err)
      })
   }

   private fetchStati() {
      Stato.getStati().then(res => {
         this.arrStati = res
         let stato = _.find(this.arrStati, x => x.data.nome == "Italia")
         this.userFrm.get('profile')?.get('indirizzo_nascita')?.patchValue(stato?.data?.id!.toString(), {emitEvent:true, onlySelf: true})
         this.setValueStato(this.utente_esercizio.data.profile.data.indirizzo_nascita.stato, 'profile', 'indirizzo_nascita')
         this.userFrm.get('profile')?.get('indirizzo_residenza')?.patchValue(stato?.data?.id!.toString(), {emitEvent:true, onlySelf: true})
         this.setValueStato(this.utente_esercizio.data.profile.data.indirizzo_residenza.stato, 'profile', 'indirizzo_residenza')
         this.userFrm.get('profile')?.get('indirizzo_domicilio')?.patchValue(stato?.data?.id!.toString(), {emitEvent:true, onlySelf: true})
         this.setValueStato(this.utente_esercizio.data.profile.data.indirizzo_domicilio.stato, 'profile', 'indirizzo_domicilio')

      }).catch(err => {
         console.error(err)
      })
   }

   async setValueProvince(value, type) {
      // console.log(value, type)
      if(!value) return;
      // console.log(type)

      await Provincia.getProvince(value).then((province) => {
         if (type == 'indirizzo_nascita'){
            console.log(type)
            this.arrProvinceNascita = province
            this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('provincia')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('citta')?.disable()

            console.log(this.arrProvinceNascita)
            console.log(this.utente_esercizio)
            console.log(this.utente_esercizio.data.profile.data.indirizzo_nascita.provincia)

            this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('provincia')?.patchValue(
               this.utente_esercizio.data.profile.data.indirizzo_nascita.provincia ?
                  this.utente_esercizio.data.profile.data.indirizzo_nascita.provincia.toString() : null)
            this.arrCittaNascita = []
         }
         if (type == 'indirizzo_residenza'){
            console.log(value)
            console.log('residenza')
            this.arrProvinceResidenza = province
            this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('provincia')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('citta')?.disable()
            this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('provincia')?.patchValue(
               this.utente_esercizio.data.profile.data.indirizzo_residenza.provincia ?
                  this.utente_esercizio.data.profile.data.indirizzo_residenza.provincia.toString() : null)
            this.arrCittaResidenza = []
         }
         if (type == 'indirizzo_domicilio'){
            console.log('domicilio')
            this.arrProvinceDomicilio = province
            this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('provincia')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('citta')?.disable()
            this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('provincia')?.patchValue(
               this.utente_esercizio.data.profile.data.indirizzo_domicilio.provincia ?
                  this.utente_esercizio.data.profile.data.indirizzo_domicilio.provincia.toString() : null)
            this.arrCittaDomicilio = []
         }
      })
   }

   async setValueCitta(value, type) {
      console.log(value, type)
      if(!value) return;

      if (type == 'indirizzo_nascita'){
         await Citta.getCitta(value).then(citta => {
            this.arrCittaNascita = citta
            console.log(this.arrCittaNascita)
            console.log(this.utente_esercizio)
            this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('citta')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_nascita')?.get('citta')?.patchValue(
               this.utente_esercizio.data.profile?.data?.indirizzo_nascita?.citta ?
                  this.utente_esercizio.data.profile?.data?.indirizzo_nascita?.citta.toString() : null)
         })
      }
      if (type == 'indirizzo_residenza'){
         await Citta.getCitta(value).then(citta => {
            this.arrCittaResidenza = citta
            console.log(this.arrCittaNascita)
            console.log(this.utente_esercizio)
            this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('citta')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_residenza')?.get('citta')?.patchValue(
               this.utente_esercizio.data.profile?.data?.indirizzo_residenza?.citta ?
                  this.utente_esercizio.data.profile?.data?.indirizzo_residenza?.citta.toString() : null)
         })
      }

      if (type == 'indirizzo_domicilio') {
         console.log(type)
         await Citta.getCitta(value).then(citta => {
            this.arrCittaDomicilio = citta
            this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('citta')?.enable()
            this.userFrm.get('profile')?.get('indirizzo_domicilio')?.get('citta')?.patchValue(
               this.utente_esercizio.data.profile?.data?.indirizzo_domicilio?.citta ?
                  this.utente_esercizio.data.profile?.data?.indirizzo_domicilio?.citta.toString() : null)
         })
      }
   }

   clickGoToEsercizio() {
      if (this.userFrm.valid){

      }
   }

   async clickModificaAmministratore(administrator: UserData, vendorSlug) {
      console.log(this.userFrm.getRawValue())
      return new Promise((resolve, reject) => {
         this.userFrm.markAllAsTouched()
         if (this.userFrm.valid){
            this.serverSrv.put(`/api/utenti/${administrator.id}/esercizi/${vendorSlug}/modifica_amministratore`,
               this.userFrm.getRawValue(), null).then(res => {
               this.dialogSrv.showToastSuccess({title:"Modifica Utente", msg:"Modifica utente completata con successo"})
               this.fetchAmministratore(vendorSlug)
               resolve(null)
            }).catch(err => {
               console.log(err)
               reject(null)
            })
         }else {
            this.userFrm.markAllAsTouched()
            reject("Form Non Valido")
         }
      })
   }

   fetchAmministratore(vendorSlug){
      this.eserciziUtentiFctr.getEsercizioUtente(this.dataSrv.user.ID, vendorSlug)
         .then(res=>{
            console.log(res)
            this.dataSrv.esercizioUser = res
            console.log(this.dataSrv.esercizioUser)
         })
         .catch(err=>{
            console.error(err)
         })
   }

   setValueStato(triggerValue: any, type1: string, type2: string, init=true) {
      console.log("setValueStato")
      console.log(triggerValue)
      let stato = _.find(this.arrStati, x => x.data.id == triggerValue)
      console.log(stato)
      let regione
      let provincia
      let citta
      if (type1 == 'profile'){
         regione = this.userFrm.get(type1)?.get(type2)?.get('regione')
         provincia = this.userFrm.get(type1)?.get(type2)?.get('provincia')
         citta = this.userFrm.get(type1)?.get(type2)?.get('citta')
      }

      if (stato?.data.nome != 'Italia'){
         regione.reset()
         provincia.reset()
         citta.reset()
         regione.disable()
         provincia.disable()
         citta.disable()
         regione.clearValidators()
         provincia.clearValidators()
         citta.clearValidators()
         regione.updateValueAndValidity({onlySelf:true})
         provincia.updateValueAndValidity({onlySelf:true})
         citta.updateValueAndValidity({onlySelf:true})
      }else {
         regione.enable()
         regione.setValidators(Validators.required)
         regione.updateValueAndValidity({onlySelf:true})
      }
   }

   setValueUsername($event) {
      this.userFrm.get('username')?.patchValue($event.target.value)
   }

   setIndirizzoDomicilio($event: MatRadioChange) {

   }

}
